module.exports = __webpack_public_path__ + "img/i-2_M4.dee799d3.svg";